import { connect } from 'react-redux';
import InAppNotificationsPage from './InAppNotificationsPage';

import { appActions } from 'App/duck';
import { inAppNotificationOperations } from './duck';

const mapStateToProps = ({
  locationReducer,
  appReducer,
  scheduleCalendarReducer,
  notificationReducer,
}) => {
  return {
    locationId: locationReducer.location_code,
    locationData: locationReducer.location_data,
    locationSettings: appReducer.location.settings,
    allUsers: scheduleCalendarReducer.allUsers.users,
  };
};

const mapDispatchToProps = (dispatch) => {

  const getInAppNotifications = (locationId) => {
    dispatch(inAppNotificationOperations.fetchInAppNotifications());
  };

  const readSingleInAppNotification = (notificationId) => {
    dispatch(inAppNotificationOperations.readSingleNotification(notificationId));
  };

  return {
    getInAppNotifications,
    readSingleInAppNotification,
  };
};

const InAppNotificationsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(InAppNotificationsPage);

export default InAppNotificationsContainer;